import React from "react";
import { __ } from "@wordpress/i18n";

const Header = () => {
	return (
		<>
			<div className="header-top">
				<div className="left-part">
					<img
						src={`${window.placAdminData.pluginUrl}/assets/images/logo.svg`}
						alt="logo-icon"
					/>
					<h1 className="heading bold secondary-text-color">{__("Access Control", "access-control")}</h1>
				</div>
				<div className="right-part">
					<ul>
						<li>
							<span>{__("1.0.0", "access-control")}</span>
							<button className="core">
								{__("Core", "access-control")}
							</button>
						</li>
						<li>
							<span>{__("N/A", "access-control")}</span>
							<button className="pro subtle-bg-color">
								{__("Pro", "access-control")}
							</button>
						</li>
						<li>
						<button className="extra-text-color secondary-bg-color">
								{__("Unlicensed", "access-control")}
							</button>
						</li>
						<li>
							<a href="#">
								<span>{__("Documentation", "access-control")}</span>
							</a>
						</li>
						<li>
							<a href="#">
								<img
									src={`${window.placAdminData.pluginUrl}/assets/images/support.svg`}
									alt={__("support", "access-control")}
								/>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</>
	);
};

export default Header;
